let countryId = {
  JP: 392,
  MX: 484,
  CO: 170,
  CR: 188
};
let countryCallingCode = {
  JP: '+81',
  MX: '+52',
  CO: '+57',
  CR: '+506',
  BR: '+55',
};
let cityId = {
  JP: 0,
  MX: 0,
  CO: 0,
  CR: 0
};
let canonicalCountryCode = {
  JP: 'JP',
  MX: 'MX',
  CO: 'CO',
  CR: 'CR'
};
let appIdPC = {
  JP: 120838,
  MX: 120838,
  CR: 200039
};
let lawUrlH5 = {
  JP: 'https://img0.didiglobal.com/static/dpubimg/16aebd1620a29cccdf3914691d87c1bb/index.html?lang=ja-JP&location_country=JP',
  MX: 'https://img0.didiglobal.com/static/dpubimg/16aebd1620a29cccdf3914691d87c1bb/index.html?lang=es-MX&location_country=MX',
  CR: 'https://img0.didiglobal.com/static/dpubimg/16aebd1620a29cccdf3914691d87c1bb/index.html?lang=es-419&location_country=CR'
}
export {
  countryId,
  appIdPC,
  lawUrlH5,
  countryCallingCode,
  cityId,
  canonicalCountryCode
}